export default __webpack_public_path__ + "static/media/arrow-down.5c080883.svg";